angular
	.module 'App.Module.Inventory.StockLocations', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'stocklocations',
				url: '/stock_locations'
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					'entity_search@stocklocations':
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				data:
					restrict: 'Backoffice.TopMenu.Stock.Stock'
					searchParams:
						repositoryName: 'StockLocationRepository'
						title: 'general.stock.locations'
						itemTemplate: '@app/stock-location/stock-location.search-result.view.html'
						newButtonSRef: "stocklocations.edit.details({id: ''})"
						filterEnabled: -> @ConfigurationService.isEnabled("Backoffice.StockManagement.StockLocations.AllowSearch")
						createEnabled: ->
							user = @UserInformation.getSubUser()

							return @ConfigurationService.isEnabled("Backoffice.StockManagement.StockLocations.EnableCreate") && _.isEmpty(user?.shops)

			.state 'stocklocations.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
						controller: 'StockLocationController'
						controllerAs: 'stockLocationEntity'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					stockLocation: (StockLocationRepository, $stateParams) ->
						return StockLocationRepository.getEntity($stateParams.id)

					shops: (ShopRepository, $stateParams) ->
						if !_.isEmpty $stateParams.id
							query = ShopRepository.createQuery()
							query.criteria 'stock_location_id', '=', $stateParams.id

							return ShopRepository.getEntities(query)

					categories: (ProductCategoryRepository, $stateParams) ->
						if !_.isEmpty($stateParams.id)
							return ProductCategoryRepository.getEntities()

					reasonCodes: (ReasonCodeRepository) ->
						return ReasonCodeRepository
							.list(true)
							.then (response) ->
								codes = _.map(
									response.data,
									(type) =>
										type.label = 'reason.code.' + type.entity_type.toLowerCase()

										return type
								)
								return _.indexBy(codes, 'id')

			.state 'stocklocations.edit.details',
				url: '/edit',
				views:
					entity_sub_view:
						controller: 'StockLocationDetailController'
						controllerAs: 'vm'
						templateUrl: "@app/stock-location/stock-location.view.html"

			.state 'stocklocations.edit.liststock',
				url: '/liststock'
				views:
					entity_sub_view:
						controller: 'StockLocationStockListController'
						controllerAs: 'vm'
						templateUrl: "@app/stock-location/stock-location.stock-list.view.html"
				data:
					parentStateName: 'stocklocations.edit.details'

			.state 'stocklocations.edit.listevents',
				url: '/listevents'
				views:
					entity_sub_view:
						controller: 'StockLocationStockEventController'
						controllerAs: 'vm'
						templateUrl: "@app/stock-location/stock-location.stock-event.view.html"
				data:
					parentStateName: 'stocklocations.edit.details'
					restrict: 'Backoffice.StockManagement.StockLocations.EnableEvents'

			.state 'stocklocations.edit.inventory_count',
				url: '/inventory_count'
				views:
					entity_sub_view:
						controller: 'StockLocationInventoryCountController'
						controllerAs: 'vm'
						templateUrl: '@app/stock-location/stock-location.inventory-count.view.html'
				data:
					parentStateName: 'stocklocations.edit.details'

			.state 'stocklocations.edit.products_to_count',
				url: '/products_to_count'
				views:
					entity_sub_view:
						controller: 'StockLocationProductCountController'
						controllerAs: 'vm'
						templateUrl: '@app/stock-location/stock-location.product-count.view.html'
				data:
					parentStateName: 'stocklocations.edit.details'
